import { useEffect } from 'react';
import toast from 'react-hot-toast';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from 'reactstrap';
import { useGetProgressReportAssessmentApprovalMutation } from 'src/rtk/features/logbookMonitoringReport/logbookMonitoringReportApi';


const ITMCApprovalViewModal = (props: any) => {
  const { isOpen, toggle, traineeData } = props;

  const [getProgressReportAssessmentApproval, { isLoading, data, isError, isSuccess }] = useGetProgressReportAssessmentApprovalMutation();
  const getMarks = (assessmentValue: number) => {
    switch (assessmentValue) {
      case 1:
        return 'Poor';
      case 2:
        return 'Good';
      case 3:
        return 'Excellent';
      default:
        return '';
    }
  };

  useEffect(() => {
    if(isSuccess){
      toast.success('Assessment approved successfully');
      toggle();
    }
    if(isError){
      toast.error('Failed to approve assessment');
    }
  }, [isSuccess, isError]);


  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle}>Assesment View</ModalHeader>
      <ModalBody>
        {
          traineeData?.assessments?.map((assessment: any, index: number) => (
            <div key={assessment.id}>
              <div className='text-center fw-semibold border border-2 bg-light'>Assessment by {assessment?.assessor_info?.details?.personal_info?.full_name ?? 'N/A'}</div>
              <h6 className='block-heading'>Recent Seen Case(Cold)</h6>
              <table className='table table-bordered table-sm'>
                <thead>
                  <tr>
                    <th className='col-sm-3'>Case</th>
                    <th className='col-sm-3'>Value</th>
                    <th className='col-sm-3'>Result</th>
                    <th className='col-sm-3'>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Point of History</td>
                    <td>{assessment?.point_in_history}</td>
                    <td>{getMarks(assessment?.point_in_history_assessment)}</td>
                    <td rowSpan={2}>{assessment?.recently_seen_case_comment}</td>
                  </tr>
                  <tr>
                    <td>Point of Examination</td>
                    <td>{assessment?.point_in_examination}</td>
                    <td>{getMarks(assessment?.point_in_examination_assessment)}</td>
                  </tr>
                </tbody>
              </table>
              <h6 className='block-heading'>Emergency Managed</h6>
              <table className='table table-bordered table-sm'>
                <thead>
                  <tr>
                    <th className='col-sm-3'>Case</th>
                    <th className='col-sm-3'>Value</th>
                    <th className='col-sm-3'>Result</th>
                    <th className='col-sm-3'>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Problem</td>
                    <td>{assessment?.problem}</td>
                    <td>{getMarks(assessment?.problem_assessment)}</td>
                    <td rowSpan={2}>{assessment?.emergency_managed_comment}</td>
                  </tr>
                  <tr>
                    <td>How Managed</td>
                    <td>{assessment?.how_managed}</td>
                    <td>{getMarks(assessment?.how_managed_assessment)}</td>
                  </tr>
                </tbody>
              </table>
              <h6 className='block-heading'>Procedure</h6>
              <table className='table table-bordered table-sm'>
                <thead>
                  <tr>
                    <th className='col-sm-3'>Case</th>
                    <th className='col-sm-3'>Value</th>
                    <th className='col-sm-3'>Result</th>
                    <th className='col-sm-3'>Comment</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Why Done</td>
                    <td>{assessment?.why_done}</td>
                    <td>{getMarks(assessment?.why_done_assessment)}</td>
                    <td rowSpan={2}>{assessment?.procedure_comment}</td>
                  </tr>
                  <tr>
                    <td>How Done</td>
                    <td>{assessment?.how_done}</td>
                    <td>{getMarks(assessment?.how_done_assessment)}</td>
                  </tr>
                </tbody>
              </table>

            </div>
          ))
        }
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={() => {
            getProgressReportAssessmentApproval(`${traineeData?.id}?itmc_approval_status=Approved`);
          }}
          disabled={isLoading || traineeData?.itmc_approval_status === 'Approved'}
        >
          Approve
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ITMCApprovalViewModal;
